import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הריפליי",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לעצור את הסרט.",
      "אני רק מזהה: הוא חוזר."
    ],
      [
      "היום אני לא מנסה לעצור את הסרט.",
      "אני רק מזהה: הוא חוזר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הסרט מתחיל לרוץ?",
      "מה הרגע שחוזר הכי הרבה?",
      "מה אני מרגיש/ה בו?"
    ],
      [
      "מתי הסרט מתחיל לרוץ?",
      "מה הרגע שחוזר הכי הרבה?",
      "מה אני מרגיש/ה בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ריפליי הוא חוויה, לא משפט סופי."
    ],
      [
      "ריפליי הוא חוויה, לא משפט סופי."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"זה ריפליי\".",
      "נשימה אחת + \"זה ריפליי\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שהריפליי מתחיל.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב לרגע שהריפליי מתחיל.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה רגע לפני שזה מתחיל?",
      "באיזה זמן ביום זה קורה?",
      "מה אני מפחד/ת שיראו?"
    ],
      [
      "מה קורה רגע לפני שזה מתחיל?",
      "באיזה זמן ביום זה קורה?",
      "מה אני מפחד/ת שיראו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מזהה את הרגע, יש לי מרחב קטן."
    ],
      [
      "כשאני מזהה את הרגע, יש לי מרחב קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשהריפליי מתחיל.",
      "נשימה אחת כשהריפליי מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "אותות הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה המתח יושב בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה המתח יושב בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "מה העובדה היבשה כאן?",
      "איזה סיפור קפץ לי?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הכאב שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בכאב שמתחת לביקורת.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בכאב שמתחת לביקורת.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה כואב לי בריפליי הזה?",
      "מה אני מפחד/ת שיחשבו עלי?",
      "מה הייתי בוחר/ת/ה לשמוע?"
    ],
      [
      "מה כואב לי בריפליי הזה?",
      "מה אני מפחד/ת שיחשבו עלי?",
      "מה הייתי בוחר/ת/ה לשמוע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כאב הוא בקשה לקרבה."
    ],
      [
      "כאב הוא בקשה לקרבה."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך לעצמי.",
      "משפט רך לעצמי."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הקול הביקורתי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול הביקורתי בלי להילחם בו."
    ],
      [
      "היום אני מקשיב/ה לקול הביקורתי בלי להילחם בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הקול הזה נשמע?",
      "מה הוא מנסה להגן עליו?",
      "מה הייתי רוצה לומר לו?"
    ],
      [
      "איך הקול הזה נשמע?",
      "מה הוא מנסה להגן עליו?",
      "מה הייתי רוצה לומר לו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול הוא רק קול."
    ],
      [
      "קול הוא רק קול."
    ]
    ),
    action: localizedGenderNode(
      "לשים לב אליו בלי להאמין לו.",
      "לשים לב אליו בלי להאמין לו."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצורך בביטחון",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לריפליי.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לריפליי.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לי להרגיע את הגוף?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לי להרגיע את הגוף?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ביטחון קטן משנה את הטון."
    ],
      [
      "ביטחון קטן משנה את הטון."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של ביטחון.",
      "לכתוב מילה אחת של ביטחון."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "להניח רגע",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הריפליי לרגע.",
      "רק רגע."
    ],
      [
      "היום אני בודק/ת איך זה מרגיש להניח את הריפליי לרגע.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ],
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להניח לרגע זו גם בחירה."
    ],
      [
      "להניח לרגע זו גם בחירה."
    ]
    ),
    action: localizedGenderNode(
      "רגע אחד בלי לחזור בסרט.",
      "רגע אחד בלי לחזור בסרט."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "שפה פנימית רכה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ],
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת אל עצמי אחרי הפגישה?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ],
      [
      "איך אני מדבר/ת אל עצמי אחרי הפגישה?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול רך מוריד לחץ."
    ],
      [
      "קול רך מוריד לחץ."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט הרך פעם אחת.",
      "לומר את המשפט הרך פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "רגע לפני שיפוט",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שיפוט עצמי.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שיפוט עצמי.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לשפוט.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לשפוט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המשפט השופט שקופץ לי?",
      "מה המחיר שלו עלי?",
      "מה אפשר לומר במקום?"
    ],
      [
      "מה המשפט השופט שקופץ לי?",
      "מה המחיר שלו עלי?",
      "מה אפשר לומר במקום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך במקום שיפוט.",
      "משפט רך במקום שיפוט."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לחזור להווה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ],
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ההווה נותן לי קרקע."
    ],
      [
      "ההווה נותן לי קרקע."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "רגע לפני בדיקה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שאני בודק/ת שוב.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שאני בודק/ת שוב.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לבדוק.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לבדוק.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני רוצה לוודא עכשיו?",
      "מה יקרה אם לא אדע מיד?",
      "מה יכול לעזור לי להמתין רגע?"
    ],
      [
      "מה אני רוצה לוודא עכשיו?",
      "מה יקרה אם לא אדע מיד?",
      "מה יכול לעזור לי להמתין רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להמתין רגע זה כוח שקט."
    ],
      [
      "להמתין רגע זה כוח שקט."
    ]
    ),
    action: localizedGenderNode(
      "לעצור רגע לפני בדיקה.",
      "לעצור רגע לפני בדיקה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן שמרגיע אותי.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן שמרגיע אותי.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן יכול לעזור לי לשחרר?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "איזה צעד קטן יכול לעזור לי לשחרר?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הריפליי הזה?",
      "מה הסימן הראשון שהוא עולה?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על הריפליי הזה?",
      "מה הסימן הראשון שהוא עולה?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const replayAfterMeetingBlueprintHe = buildNormalizedPilotBlueprint({
  id: "replay_after_meeting_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "replay_after_meeting",
  category: "anxiety",
  journeyName: {
    he: "replay בראש אחרי פגישה - \"למה אמרתי ככה...\"",
    en: "Replay in my head after a meeting - \"Why did I say that...\"",
    es: "Repeticion en mi cabeza despues de una reunion - \"Por que dije eso...\"",
  },
  days,
});

export default replayAfterMeetingBlueprintHe;
